export const variousAsn = 'VARIOUS';

export const SUPER_ADMINS = [
  'Gavin.Dillon@mrl.com.au',
  'Matt.Tye@mrl.com.au',
  'Jeff.Scherpenzeel@mrl.com.au',
  'Krissa.DeTorres@mrl.com.au'
];

export const UAT_SUPER_ADMINS = [
  ...SUPER_ADMINS,
  ...['Billy.Li@mrl.com.au', 'liheng.zhang@mrl.com.au', 'subhani.munasinghe@mrl.com.au']
];
